import Model from '@/models/Model'

export default class HrPreviredCompensationFound extends Model {
    resource() {
        return 'hr_previred_compensation_fund'
    }

    
}